//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UseCases',
  data () {
    return {
      cases: [
        {
          img: require('@/assets/img/pagsmile-card/works/image4.png'),
          text: 'E-Commerce'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image2.png'),
          text: 'Online Travel Agencies'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image5.png'),
          text: 'Gaming'
        },
        {
          img: require('@/assets/img/pagsmile-card/works/image6.png'),
          text: 'Publishers'
        }
      ]
    }
  }
}
